import { Builder } from '@builder.io/react'
import React from 'react'

interface Props {
  backgroundColor: string
  skeletonColor: string
  numberOfLines: number
  headline: boolean
  height: string
}

const SkeletonText = ({ backgroundColor, skeletonColor, numberOfLines, headline, height }: Props) => {
  const getTextLines = () => {
    return (
      <>
        {Array.from({ length: numberOfLines }, (_, index) => (
          <div
            key={index}
            className="h-2 rounded-full bg-gray-300 max-w-[32rem] mb-2.5 mx-auto flex"
            style={{ backgroundColor: skeletonColor }}
          ></div>
        ))}
      </>
    )
  }

  return (
    <div className={`p-6 w-full h-[${height}]`} style={{ backgroundColor: backgroundColor }}>
      <div role="status" className="w-full animate-pulse">
        {headline && (
          <div
            className="h-2.5 rounded-full bg-gray-300 w-48 mb-4 flex mx-auto"
            style={{ backgroundColor: skeletonColor }}
          ></div>
        )}
        {getTextLines()}

        <span className="sr-only">Loading...</span>
      </div>
    </div>
  )
}
export default SkeletonText

Builder.registerComponent(SkeletonText, {
  name: 'SkeletonText',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#f9f5f1'
    },
    {
      name: 'skeletonColor',
      type: 'color',
      defaultValue: '#e0e0e0'
    },
    {
      name: 'numberOfLines',
      type: 'number',
      defaultValue: 3
    },
    {
      name: 'headline',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'height',
      type: 'string',
      defaultValue: '14rem'
    }
  ]
})
